import React from "react";
import _ from "lodash";

import { getImage, GatsbyImage } from "gatsby-plugin-image";

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import VideocamIcon from '@mui/icons-material/Videocam';
import ImageIcon from '@mui/icons-material/Image';

const getEntityUrl = ({ entity, defaultLocale, switchLocale }) => {
    const locale = switchLocale?.code || entity.locale;
    return `${locale !== defaultLocale ? `/${locale}` : ''}/entity/${entity.identifier}.html`;
}

const getTranslatedTopbarEntities = (settings, entities, curLocale) => {
    if (!curLocale) return [];

    const topbarEntities = settings?.Topbar?.entities;

    const translatedTopbarEntites = [];
    _.each(topbarEntities, e => {
        if (e.locale !== curLocale) {
            const transE = _.find(entities?.nodes, { identifier: e.identifier, locale: curLocale });
            if (transE) translatedTopbarEntites.push(transE);
        } else {
            translatedTopbarEntites.push(e);
        }
    });

    return translatedTopbarEntites;
}

const getOverlayImages = (listRole, files) => {
    const zIndex = 700;
    return listRole?.overlays.map((i, n) => {
        const style = {
            position: 'absolute',
            display: 'block',
            width: i.width || '66%',
        }
        switch (i.alignment) {
            case 'top':

                style.top = 0;
                if (i.margin) style.marginTop = i.margin;
                break;
            case 'center':

                style.bottom = '50%';
                style.transform = 'translateY(50%)';
                break;
            case 'bottom':


                style.bottom = 0;
                if (i.margin) style.marginBottom = i.margin;
                break;
            default:

                break;

        }
        if (i.left) style.left = i.left;

        const localFile = _.find(files.nodes, { id: i.image?.localFile___NODE });
        return <GatsbyImage zIndex={zIndex + n} image={getImage(localFile)} alt="" style={style} />

    });
};

const getTranslatedEntityLink = ({ locale, defaultLocale, entity }) => {
    //default to root if entity not available in selected lang
    let link = getEntityUrl({ entity: { identifier: 'root' }, switchLocale: locale, defaultLocale });

    if (_.find(entity.localizations, { locale: locale.code })) {
        link = getEntityUrl({ entity, defaultLocale, switchLocale: locale });
    }
    return link;
};

const getAccessoryIcon = ({ defaultIcon, role }) => {
    switch (role?.accessoryIcon) {
        case 'arrowRight':
            return ArrowForwardIosIcon;
        case 'speaker':
            return VolumeMuteIcon;
        case 'video':
            return VideocamIcon;
        case 'text':
            return FormatAlignLeftIcon;
        case 'image':
            return ImageIcon;
        case 'none':
            return React.Fragment;
        default:
            return defaultIcon || ArrowForwardIosIcon;
    }
};

export { getEntityUrl, getTranslatedTopbarEntities, getOverlayImages, getTranslatedEntityLink, getAccessoryIcon };
